module.exports = __webpack_public_path__ + "static/media/org_sample.511b3266.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/org_sample.JPG
// module id = 1434
// module chunks = 1